export const setMobileResponsive = (store) => {
  if (typeof window.matchMedia !== 'undefined') {
    const matchMedia = window.matchMedia('(max-width: 767px)');
    matchMedia.addEventListener('change', (event) => {
      store.dispatch('setMobileResponsive', event.matches);
    });
    store.dispatch('setMobileResponsive', matchMedia.matches);
  }
};

export default { setMobileResponsive };
